/**********cookie操作**************/

export default {
  // more 更多参数
  setCookie: (name, value, day = 30, more = '') => {
    if (day === "undefined") {
      document.cookie = name + "=" + value;
    }
    else {
      let d = new Date();
      d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/" + more;
    }
  },

  deleteCookie: (name, more = '') => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/" + more;
  },

  getCookie: (cName) => {
    let name = cName + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
  },

  //清空cookie
  clearCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
        document.cookie = keys[i] + '=0;path=/;gaokaozhitongche.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
      }
    }
    console.log('已清除');
  }
}